import * as React from "react";
const SvgFiRrTreeDeciduous = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tree-deciduous_svg__a)">
      <path
        fill="#062147"
        d="M18.483 5.157c-.315-.067-.59-.371-.703-.772A6.02 6.02 0 0 0 12 0a6.02 6.02 0 0 0-5.78 4.385c-.112.401-.388.705-.703.772a7 7 0 0 0-5.514 7.058C.115 15.956 3.367 19 7.251 19h3.75v4a1 1 0 1 0 2 0v-4h2.783c4.641 0 8.095-2.854 8.213-6.785a7 7 0 0 0-5.514-7.058m3.515 6.997C21.912 15.008 19.358 17 15.784 17H13v-1.586l3.707-3.707a.999.999 0 1 0-1.414-1.414L13 12.586V9a1 1 0 1 0-2 0v3.586l-2.293-2.293a.999.999 0 1 0-1.414 1.414L11 15.414V17H7.251c-2.814 0-5.169-2.174-5.249-4.846a5 5 0 0 1 3.936-5.042c1.048-.226 1.895-1.064 2.208-2.19A4.01 4.01 0 0 1 12 2a4.01 4.01 0 0 1 3.853 2.922c.314 1.126 1.16 1.965 2.208 2.19a5 5 0 0 1 3.938 5.042"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tree-deciduous_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTreeDeciduous;
